var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOppositeDirections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "opposite-directions_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M22 16H4.414l3.293-3.293a1 1 0 00-1.414-1.414l-5 5a1 1 0 000 1.414l5 5a1 1 0 101.414-1.414L4.414 18H22a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.707 1.293a1 1 0 00-1.414 1.414L19.586 6H2a1 1 0 000 2h17.586l-3.293 3.293a1 1 0 101.414 1.414l5-5a1 1 0 000-1.414z"
  }))));
}

export default SvgOppositeDirections;